module.exports = __webpack_public_path__ + "622bf373fa3643b5bc6dc8cd0e6a662a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/iyv-thumbs/pff-thumbnail.jpg
// module id = 1973
// module chunks = 0